export default __webpack_public_path__ + "static/media/responsive-demo-amazon-clone.71733e3a.png";